import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'app-radio-selector',
    templateUrl: './radio-selector.component.html',
    styleUrls: ['./radio-selector.component.scss']
})
export class RadioSelectorComponent implements OnInit {
    @Input() value: boolean;
    @Input() type: boolean;

    @Output() onValueChange = new EventEmitter<boolean>();

    constructor() {
    }

    ngOnInit() {
    }

    changeValue(value) {
        this.value = value;
        this.onValueChange.emit(value);
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/radio-selector/radio-selector.component.ts